var render, staticRenderFns
import script from "./formAdd.vue?vue&type=script&lang=js"
export * from "./formAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1283cc94')) {
      api.createRecord('1283cc94', component.options)
    } else {
      api.reload('1283cc94', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/order_display/document_display/form/components/formAdd.vue"
export default component.exports